<template>
  <div class="carousel-framed__slide carousel-framed__slide__text-wrapper">
    <component v-if="isMobile"
      :is="item.linkSlide ? 'a' : 'div'"
      class="carousel-framed__slide--text"
      :href="item.linkSlide ? item.linkSlide.url : null "
      :target="item.linkSlide ? target(item.onBlank) : null"
      :rel="item.linkSlide ? rel(item.noFollow, item.onBlank) : null"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >

        <div 
          key="mobile-content"
          class="carousel-framed__content--mobile"
        >
          <p class="carousel-framed__text carousel-framed__text--over ">{{ item.overTitleSlide }}</p>
          <p class="carousel-framed__text carousel-framed__text--main ">{{ item.titleSlide }}</p>
          <p class="carousel-framed__text carousel-framed__text--under ">{{ item.underTitleSlide }}</p>
        </div>
    </component>
  </div>

</template>


<script>

export default {
  name: 'CarouselFramedSlideText',
  props: {
    item: Object,
    size: String,
    active: Boolean,
    showContent: Boolean, // <--- gestito dal genitore quando la transizione finisce
    direction: {
      type: String,
      default: 'left'
    },
  },
  data() {
    return {
      touchStartTime: null,
      longPressTimer: null
    };
  },
  mounted() {
  },
  computed: {
    isMobile() {
      return this.$mq  === 'small' || this.$mq   === 'medium';
    }
  },
  methods: {
    mediaDataUrl(item) {
      if (this.$mq === "small") {
        return item.mediaMobile?.url ?? item.media.url
      } else {
        return item.media.url
      }
    },
    onTouchStart() {
      this.touchStartTime = Date.now();
      this.longPressTimer = setTimeout(() => {
        this.$emit('longpress', true);
      }, 500);
    },
    onTouchEnd() {
      clearTimeout(this.longPressTimer);
      if (Date.now() - this.touchStartTime < 500) {
        this.$emit('longpress', false);
      }
    },
    pauseOnHover() {
      this.isPaused = true;
      clearInterval(this.interval);
    },
    resumeOnHover() {
      if (!this.isPaused) return;
      this.isPaused = false;
      this.startAutoplay();
    },
    target: function(isBlank) {
      return isBlank ? "_blank" : "_self";
    },
    rel: function(noFollow, targetBlank) {
      const attribute = targetBlank ? "noopener " : "";

      return noFollow ? attribute + "nofollow" : attribute;
    },
  }
};
</script>
